// extracted by mini-css-extract-plugin
export default {"usageWarning":"f3GyJpp9uy","root":"Q4zfsEPqX6","table":"KDLOitjOoW"};